angular.module('impactx.cube').controller('CubeConfigCtrl', CubeConfigCtrl);

CubeConfigCtrl.$inject = ['CubeConfigService', 'themeFactory', '$filter', '$timeout', '$q'];

function CubeConfigCtrl(CubeConfigService, themeFactory, $filter, $timeout, $q) {

    var vm = this;

    CubeConfigService.init(vm).then(function () {
        vm.selectedCube = CubeConfigService.selectedCube;
    });

    this.selectCube = function (cube) {
        CubeConfigService.selectCube(cube).then(function () {
            vm.data.filters = CubeConfigService.filters;
        });
    };

    this.addColumn = CubeConfigService.addColumn;

    this.removeColumn = CubeConfigService.removeColumn;

    this.addRow = CubeConfigService.addRow;

    this.removeRow = CubeConfigService.removeRow;

    this.addMeasure = CubeConfigService.addMeasure;

    this.removeMeasure = CubeConfigService.removeMeasure;

    this.getTheme = themeFactory.getTheme;

    this.cancel = CubeConfigService.cancel;

    this.checkAndRedirect = CubeConfigService.checkAndRedirect;

    this.hide = function() {
        if(vm.selectedCube.cube != null) {
            CubeConfigService.close();
        }
    };



    this.filterItems = function(filter)
    {
        $timeout.cancel(vm.promise);
        vm.promise = $timeout(filterDelegates, 200,true,{items: filter.elements, searchText: filter.searchText});
        return vm.promise;
    };
    var filterDelegates = function(params)
    {
        if(params.searchText.length < 2)
        {
            return $filter('filter')([], params.searchText);
        }
        else
        {
            return $filter('filter')(params.items, {value: params.searchText})
        }
    }


}